// extracted by mini-css-extract-plugin
export var avatarContainer = "_8b-0";
export var avatarTypingWave = "_8b-i";
export var gray = "_8b-f";
export var green = "_8b-c";
export var icon = "_8b-9";
export var image = "_8b-1";
export var lg = "_8b-6";
export var md = "_8b-5";
export var presenceDot = "_8b-b";
export var red = "_8b-d";
export var sm = "_8b-4";
export var status = "_8b-a";
export var typingDot = "_8b-h";
export var typingPill = "_8b-g";
export var xl = "_8b-7";
export var xs = "_8b-3";
export var xxl = "_8b-8";
export var xxs = "_8b-2";
export var yellow = "_8b-e";